"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
var uuid = require("uuid");
ngModule.factory("UUID", function () {
  return function UUID() {
    return uuid.v4(); // using node-uuid
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/UUID.js
// module id = 2743
// module chunks = 13